module.exports = __webpack_public_path__ + "51b3d8bff31ed911bfb5541e200ce246.png";